import React from 'react';
import { ResponsiveContainer } from 'components/atomic/atoms/responsive-container';
import { ActionsStickyFooterVariant } from './sticky-footer-variant';
import type { ActionsSectionProps } from './types';

/**
 * ListingActionsSection
 * 
 * Mobile sticky footer with CTA buttons (Request Info, Book Showing).
 * 
 * @example
 * ```tsx
 * <ListingActionsSection
 *   sectionId="listing-actions"
 *   show="mobile"
 *   data={{
 *     primaryAction: {
 *       label: "Request More Info",
 *       onClick: openPVR
 *     },
 *     secondaryAction: {
 *       label: "Book a Showing",
 *       onClick: openBookShowing
 *     }
 *   }}
 * />
 * ```
 */
export function ListingActionsSection({
  sectionId,
  show = 'mobile',
  data,
  className,
}: ActionsSectionProps) {
  return (
    <ResponsiveContainer
      show={show}
      as="section"
      data-section={sectionId}
      className={className}
    >
      <ActionsStickyFooterVariant data={data} />
    </ResponsiveContainer>
  );
}

export type { ActionsSectionProps, ActionsSectionData } from './types';
